import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex q-gutter-xs" }

import { ref, watch, withDefaults } from 'vue'
import BaseRadio from './base/radio.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
    placeholder: null,
    qa: null,
    qb: null,
    qc: null,
    qd: null,
    qe: null,
    required: { type: Boolean },
    readonly: { type: Boolean },
    suffix: null,
    prefix: null,
    modelValue: null
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as { placeholder?: string, qa: string, qb: string, qc?: string, qd?: string, qe?: string, required: boolean, readonly?: boolean, suffix?: string, prefix?: string, modelValue: string | null }





const innerModelValue = ref('')

watch(
  () => props.modelValue,
  () => {
    innerModelValue.value = props.modelValue ?? ''
  },
  { immediate: true },
)

watch(innerModelValue, () => {
  emit('update:modelValue', innerModelValue.value)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (i) => {
        return _createElementVNode("div", {
          class: "col-grow",
          key: `option_${i}`
        }, [
          _createVNode(BaseRadio, {
            value: String(i),
            label: [__props.qa, __props.qb][i - 1],
            readonly: __props.readonly,
            modelValue: innerModelValue.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((innerModelValue).value = $event))
          }, null, 8, ["value", "label", "readonly", "modelValue"])
        ])
      }), 64))
    ])
  ]))
}
}

})